export default __webpack_public_path__ + "static/media/AO-7.0866d945.jpg";